const modalEditPhotoModalEquipServiceQuest = {
  title: 'Editar la foto de la pregunta'
};

export default modalEditPhotoModalEquipServiceQuest;
